import styled from 'styled-components'

import { device } from 'common/Device'

import { GiftLineItem, GiftItemHeader, defaultPrintFontSize } from './PrintStyles'
import { formatAmount } from '../mygivingutil'

const GiftAmountStyles = styled.div`
  text-align:right;
  margin-top:${ 30/defaultPrintFontSize }em;

  .receipt-amount-section {
    margin-bottom:${ 8/defaultPrintFontSize }em;

    > * {
      display:flex;
      margin:${ 5/defaultPrintFontSize }em 0;
    }

    ${ GiftItemHeader }, ${ GiftLineItem } {
      flex:1 0 50%;
    }
  }

  .tribute {
    font-weight:600;
  }

  .ira-disclaimer {
    margin-top: ${ 10/defaultPrintFontSize }em;
    text-align: left;
  }

  @media screen and ${ device.tablet } {
    margin-top:${ 20/defaultPrintFontSize }em;
  }

  @media screen and ${ device.mobile } {
    margin-top:${ 15/defaultPrintFontSize }em;
  }
`

const ReceiptGiftSingle = props => {
  // console.log({props})
  return (
    <GiftAmountStyles>
      <div className="receipt-amount-section">
        <div>
          <GiftItemHeader>Gift Amount:</GiftItemHeader>
          <GiftLineItem className="has-underline">{ formatAmount(props.data.displayAmount) }</GiftLineItem>
        </div>
        <div>
          <GiftItemHeader>Tax Deductible Amount:</GiftItemHeader>
          <GiftLineItem className="has-underline">{ formatAmount(props.data.taxDeductibleAmount) }</GiftLineItem>
        </div>
        {props.data.paymentMethod === "Stock" &&
          <div>
            <GiftItemHeader>Gift Details:</GiftItemHeader>
            <GiftLineItem className="has-underline">{ props.data.giftDetails }</GiftLineItem>
          </div>}
      </div>

      { props.data.tributeText1 && props.data.tributeText1.length &&
        <div className="tribute">{ props.data.tributeText1.charAt(0).toUpperCase() + props.data.tributeText1.slice(1) }</div> }

      { props.data.tributeText2 && props.data.tributeText2.length &&
       <div className="tribute">{ props.data.tributeText2.charAt(0).toUpperCase() + props.data.tributeText2.slice(1) }</div> }

      { props.data.benefitAmount === 0 &&
        <div className="tribute">No goods or services were received for this donation.</div> }

      { props.data.receiptType === "IRA" &&
        <div className="ira-disclaimer">We are confirming receipt of your gift which was received directly from your plan trustee/administrator and that it is your intention for all or a portion of your gift to qualify as a qualified charitable distribution from your IRA under section 408(d)(8) of the Internal Revenue Code. UCLA is a qualified organization under section 170(b)(1)(A) of the Internal Revenue Code. Your gift was not transferred to either a donor-advised fund or a supporting organization as described in section 509(a)(3). Please retain this receipt with your important tax documents and provide a copy to your tax preparer.</div>}
    </GiftAmountStyles>
  )
}

export default ReceiptGiftSingle
